import { NgModule } from '@angular/core'
import {
  ArrowDownUp,
  ArrowLeft,
  ArrowLeftRight,
  ArrowRight,
  ArrowUp,
  Bell,
  Building2,
  Calendar,
  Check,
  CheckSquare,
  ChevronDown,
  ChevronFirst,
  ChevronLast,
  ChevronUp,
  Clock,
  CloudUpload,
  Cookie,
  CreditCard,
  Download,
  Edit,
  EllipsisVertical,
  Eye,
  EyeOff,
  File,
  FileText,
  Filter,
  House,
  Image,
  Info,
  LayoutDashboard,
  LayoutGrid,
  LifeBuoy,
  ListCollapse,
  LockKeyhole,
  LogOut,
  LucideAngularModule,
  Mail,
  MapPin,
  Menu,
  MessageSquareText,
  Mic,
  Moon,
  PanelLeftClose,
  PanelRightClose,
  Paperclip,
  Pencil,
  PencilRuler,
  Phone,
  PhoneCall,
  Plus,
  RefreshCw,
  Scale,
  ScrollText,
  Search,
  Settings,
  Settings2,
  Shield,
  Siren,
  SquareDashedMousePointer,
  Sun,
  Tag,
  Trash,
  Trash2,
  Undo2,
  User,
  UserCog,
  UserPlus,
  Users,
  Wallet,
  Webcam,
  X,
} from 'lucide-angular'

@NgModule({
  imports: [
    LucideAngularModule.pick({
      CloudUpload,
      Search,
      LockKeyhole,
      EyeOff,
      Bell,
      Mail,
      Calendar,
      Menu,
      UserCog,
      LayoutDashboard,
      ArrowLeftRight,
      Users,
      Wallet,
      ScrollText,
      PanelRightClose,
      Siren,
      Settings,
      LifeBuoy,
      LogOut,
      ChevronFirst,
      ChevronLast,
      ChevronDown,
      ChevronUp,
      X,
      ArrowLeft,
      Sun,
      SquareDashedMousePointer,
      Moon,
      PanelLeftClose,
      Filter,
      Plus,
      EllipsisVertical,
      Pencil,
      Trash2,
      ArrowDownUp,
      Phone,
      MapPin,
      Webcam,
      PhoneCall,
      ArrowRight,
      ArrowUp,
      Download,
      Undo2,
      File,
      Scale,
      MessageSquareText,
      House,
      Clock,
      User,
      LayoutGrid,
      ListCollapse,
      Paperclip,
      Check,
      Building2,
      Image,
      Mic,
      PencilRuler,
      Eye,
      CheckSquare,
      UserPlus,
      Edit,
      Trash,
      Tag,
      CreditCard,
      Settings2,
      Info,
      RefreshCw,
      FileText,
      Cookie,
      Shield,
    }),
  ],
  exports: [LucideAngularModule],
})
export class LucideModule {}
